import api from "../../lib/api";

export interface NodeCommentTarget {
  nodeType: "company" | "person" | "address";
  nodeKey: string;
  typeLabel: "Company" | "Person" | "Address";
  displayLabel: string;
}

export interface NodeComment {
  nodeType: string;
  nodeKey: string;
  commentMarkdown: string;
  createdAt: string;
  updatedAt: string;
}

const buildNodeCommentQuery = (target: NodeCommentTarget): string =>
  `nodeType=${encodeURIComponent(target.nodeType)}&nodeKey=${encodeURIComponent(target.nodeKey)}`;

export const getNodeComment = async (target: NodeCommentTarget): Promise<NodeComment> => {
  return api.get<NodeComment>(`/v1/nodecomments?${buildNodeCommentQuery(target)}`);
};

export const saveNodeComment = async (
  target: NodeCommentTarget,
  commentMarkdown: string,
): Promise<NodeComment> => {
  return api.put<NodeComment>("/v1/nodecomments", {
    nodeType: target.nodeType,
    nodeKey: target.nodeKey,
    commentMarkdown,
  });
};

export const deleteNodeComment = async (target: NodeCommentTarget): Promise<void> => {
  await api.delete(`/v1/nodecomments?${buildNodeCommentQuery(target)}`);
};
